
export default {
    state:{
      subido: false,
      
    },
  
    
    mutations: {
  
      setSubidoEncuesta( state, data) {
        state.data = data
        state.subido = true
        
         
      },
  
      resetSubidoEncuesta( state ) {
        state.subido = false
      }
    }
  }
  